import { render, staticRenderFns } from "./WithdrawList.vue?vue&type=template&id=11948e03&scoped=true"
import script from "./WithdrawList.vue?vue&type=script&lang=ts"
export * from "./WithdrawList.vue?vue&type=script&lang=ts"
import style0 from "./WithdrawList.vue?vue&type=style&index=0&id=11948e03&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11948e03",
  null
  
)

export default component.exports